import { createAsyncThunk } from '@reduxjs/toolkit';
import { getZendeskPodDataTicketId } from 'services/pod';
import { IPodData } from 'services/pod/types';

interface IProps {
  psaId: number;
  ticketId: number;
}

export const ThunkGetZendeskPodDataByTicketId = createAsyncThunk<IPodData, IProps>(
  'pod/getZendeskPodDataTicketId',
  async ({ psaId, ticketId }) => getZendeskPodDataTicketId(psaId, ticketId).then(r => r.data),
);
